// pv-toast.js — Convierte el promo-popup en un toast no bloqueante
// Se auto-cierra a los 4 segundos. Compatible con el popup nativo Dawn.
(function(){
  var DELAY=4000;
  function autoClose(el){
    if(!el)return;
    setTimeout(function(){
      el.classList.remove('popup-modal--active');
      var ov=document.querySelector('.popup-overlay.popup-overlay--active,.sign-up-popup-overlay.popup-overlay--active,.success-popup-overlay.popup-overlay--active');
      if(ov)ov.classList.remove('popup-overlay--active');
    },DELAY);
  }
  // Observar cuando el popup se activa (activa la clase popup-modal--active)
  var observer=new MutationObserver(function(muts){
    muts.forEach(function(m){
      if(m.target.classList&&m.target.classList.contains('popup-modal--active'))autoClose(m.target);
    });
  });
  document.querySelectorAll('.popup-modal,.sign-up-popup-modal,.success-popup-modal').forEach(function(m){
    observer.observe(m,{attributes:true,attributeFilter:['class']});
  });
  // Si ya está activo al cargar (modo testing)
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.popup-modal.popup-modal--active').forEach(autoClose);
  });
})();
